import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Props {
    cat_name: string
    sub_cat_name?: string
    name: string
    className?: string
    children: JSX.Element
};

export function CustomLink(props: Props) {
    const [url, SetUrl] = useState('')

    useEffect(() => {
        if (props.name === 'category') {
            SetUrl(`category/${props.cat_name}`)
        } else if (props.name === 'sub-category') {
            SetUrl(`category/${props.cat_name}/sub-category/${props.sub_cat_name}`)
        }
    }, [url])

    return (
        <Link to={url} className={props.className}>
            {props.children}
        </Link>
    )
}
